import localeModule from 'timeago.js/lib/lang/ar'
const localeName = 'ar'
export default { locale: localeName, module: localeModule }
